import { initDarkModeToggles } from "../../../utils/dark-mode-toggles";

export function Appearance() {
  function init() {
    const $sectionElem = document.getElementById("profile-appearance-section") as HTMLElement
    initDarkModeToggles($sectionElem); // initialize the dark mode toggle buttons
  }

  function render() {
      return /*html*/`<div id="profile-appearance-section" class="py-6 sm:py-8 space-y-5 border-t border-gray-200 first:border-t-0 dark:border-neutral-700">
                            <div class="inline-flex items-center gap-x-2">
                              <h2 class="font-semibold text-gray-800 dark:text-neutral-200">
                                Apperance
                              </h2>
                            </div>
                            
                            <!-- Grid -->
                            <div class="grid sm:grid-cols-12 gap-y-1.5 sm:gap-y-0 sm:gap-x-5">
                              <div class="sm:col-span-4 xl:col-span-3 2xl:col-span-2">
                                <label class="sm:mt-2.5 inline-block text-sm text-gray-500 dark:text-neutral-500">
                                  Choose Theme
                                </label>
                              </div>
                              <!-- End Col -->
                
                              <div class="sm:col-span-8 xl:col-span-8">
                                <div class="mt-5">
                                  <!-- Grid -->
                                  <div class="grid grid-cols-3 gap-x-2 sm:gap-x-4 mt-4">
                                    <!-- Light Mode -->
                                    <label for="light-mode" class="w-full sm:w-auto flex flex-col bg-white text-center cursor-pointer rounded-xl ring-1 ring-gray-200 has-[:checked]:ring-2 has-[:checked]:ring-blue-600 dark:bg-neutral-800 dark:text-neutral-200 dark:ring-neutral-700 dark:has-[:checked]:ring-blue-500">
                                      <input type="radio" id="light-mode" name="theme-mode" class="hidden theme-radio" value="light">
                                      <img class="rounded-t-[14px]" src="/images/light.svg" alt="Light">
                                      <span class="py-3 px-2 text-sm font-semibold text-gray-800 dark:text-neutral-200">
                                        Light
                                      </span>
                                    </label>

                                    <!-- Dark Mode -->
                                    <label for="dark-mode" class="w-full sm:w-auto flex flex-col bg-white text-center cursor-pointer rounded-xl ring-1 ring-gray-200 has-[:checked]:ring-2 has-[:checked]:ring-blue-600 dark:bg-neutral-800 dark:text-neutral-200 dark:ring-neutral-700 dark:has-[:checked]:ring-blue-500">
                                      <input type="radio" id="dark-mode" name="theme-mode" class="hidden theme-radio" value="dark">
                                      <img class="rounded-t-[14px]" src="/images/dark.svg" alt="Dark">
                                      <span class="py-3 px-2 text-sm font-semibold text-gray-800 dark:text-neutral-200">
                                        Dark
                                      </span>
                                    </label>
                                  </div>
                                  <!-- End Grid -->
                                </div>
                              </div>
                              <!-- End Col -->
                            </div>
                            <!-- End Grid -->
                          </div>`;
  }

  return { render, init };
}